import React from 'react';
import { Container } from '@pixi/react';
import { observer } from 'mobx-react-lite';

import Info from '../../../components/common/info';
import PayTableContent from '../../../components/common/info/payTable/payTableContent';
import GameRulesContent from '../../../components/common/info/gameRules/gameRulesContent';

import InfoSectionBackground from '../../../components/common/info/InfoSectionBackground';
import { jackPotStore } from '../../../store/jackPotStore';

const InfoSectionContainer = observer(() => {
  return (
    <Container name='InfoSectionContainer'>
      <InfoSectionBackground />
      <Info
        PayTableContent={PayTableContent}
        payTableStepCount={jackPotStore.hasJackPot ? 5 : 4}
        payTableContentWidth={1440}
        GameRulesContent={GameRulesContent}
      />
    </Container>
  );
});

export default InfoSectionContainer;
